import { intervalToDuration } from 'date-fns';

export const getDifferenceOfDatesInDuration = (start: Date, end: Date) => {
  const duration = intervalToDuration({ start, end });
  const array = [];
  if (duration) {
    if (duration.days) {
      array.push(`${duration.days} ${duration.days === 1 ? 'day' : 'days'}`);
    }
    if (duration.hours) {
      array.push(`${duration.hours} ${duration.hours === 1 ? 'hour' : 'hours'}`);
    }
    if (!array.length && duration.minutes) {
      return `${duration.minutes} ${duration.minutes === 1 ? 'minute' : 'minutes'}`;
    }
    if (!array.length && duration.seconds) {
      return `${duration.seconds} ${duration.seconds === 1 ? 'second' : 'seconds'}`;
    }
  }
  return array.join(', ');
};
